import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 5L2.86732 17.1425C2.94208 18.1891 3.81296 19 4.86224 19H13.1378C14.187 19 15.0579 18.1891 15.1327 17.1425L16 5M11 9L11 15M7 9V15M6 5V2C6 1.44772 6.44772 1 7 1L11 1C11.5523 1 12 1.44772 12 2V5M17 5L1 5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }